//
// LoadingGate - Shows a progress bar until all registered loaders complete.
//
// Place this component BELOW providers that need to load resources,
// but ABOVE components that need those resources to render.
//
// Providers above the gate mount immediately and start loading in parallel.
// Children below the gate only mount when all active loaders are complete.
//

import PropTypes from 'prop-types';

import useLoadingProgress from '../utils/useLoadingProgress';

import PaxityProgress from './PaxityProgress';
import ProgressBar from './ProgressBar';
import SupportLink from './SupportLink';

function LoadingGate(props) {
  const {
    children,
    debug = false,
  } = props;

  const {
    allComplete,
    progress,
    total,
    done,
    loaders,
  } = useLoadingProgress();

  if (!allComplete) {
    return (
      <div className="relative w-screen h-screen max-h-screen bg-white flex flex-col justify-center items-center text-pxGrey overflow-hidden px-4 py-2">
        <div className="relative w-full max-w-md flex flex-col m-auto items-center gap-6">

          <PaxityProgress />

          <ProgressBar
            progress={progress}
            done={done}
            total={total}
          />

          {/* Debug info */}
          {debug && (
            <div className="text-xs text-pxTxtFaint font-mono">
              {loaders.map((l, i) => (
                <div key={l.label || i}>
                  {`${l.label}: ${l.status}`}
                </div>
              ))}
            </div>
          )}

          <SupportLink delayMs={10000} />

        </div>
      </div>
    );
  }

  return children;
}

LoadingGate.propTypes = {
  children: PropTypes.node.isRequired,
  debug: PropTypes.bool,
};

export default LoadingGate;
